import * as Sentry from '@sentry/browser'
import debounce from 'lodash/debounce'
import {
  PREPARE_AIRDNA_REQUEST,
  FETCH_AIRDNA_REQUEST,
  FETCH_AIRDNA_SUCCESS,
  FETCH_AIRDNA_FAILURE,
  SET_AIRDNA_SETTINGS
} from './actionTypes'
import { fetchAirDna as tokenFetchResource } from '../api/mikasa/token_requests'
import { fetchAirDna as fetchResource } from '../api/mikasa/requests'
import { flashNotification } from './notification'
import { ERRORS } from '../constants/messages'
import { updateBuyerInfo } from './buyerInfo'
import { execute } from '../vendor/recaptcha'

export const prepareStateKey = stateKey => ({
  type: PREPARE_AIRDNA_REQUEST,
  stateKey
})

const fetchWithMethod =
  fetchMethod =>
  (stateKey, { address }) =>
  async (dispatch, getState) => {
    const params = { address }

    dispatch({
      type: FETCH_AIRDNA_REQUEST,
      stateKey
    })

    let validationToken

    try {
      validationToken = await execute({ action: 'request_rental_potential' })
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
    }

    try {
      const response = await fetchMethod({
        ...params,
        validationToken
      })
      if (response?.data?.payload?.stats?.future?.summary) {
        dispatch({
          type: FETCH_AIRDNA_SUCCESS,
          stateKey,
          params,
          settings: {
            pricePerNight: Math.round(response.data.payload.stats.future.summary.adr * 0.7),
            nightsPerMonth: Math.round(response.data.payload.stats.future.summary.occupancy * 30 * 0.7)
          },
          data: response.data?.payload
        })
      } else {
        dispatch({
          type: FETCH_AIRDNA_FAILURE,
          stateKey,
          error: 'No data found'
        })
      }
    } catch (error) {
      dispatch({
        type: FETCH_AIRDNA_FAILURE,
        stateKey,
        error
      })

      dispatch(
        flashNotification({
          message: [ERRORS.defaultHeadline, ERRORS.defaultMessage],
          messageType: 'error'
        })
      )
    }
  }

export const fetchAirDna = fetchWithMethod(fetchResource)

export const tokenFetchAirDna = fetchWithMethod(tokenFetchResource)

export const updateSettings = (stateKey, settings) => dispatch => {
  dispatch({
    type: SET_AIRDNA_SETTINGS,
    stateKey,
    settings
  })

  dispatch(persistSettings(stateKey))
}

const withDispatchUpdate = debounce((dispatch, ...args) => dispatch(updateBuyerInfo(...args)), 3000)

const persistSettings = stateKey => (dispatch, getState) => {
  const { nightsPerMonth, pricePerNight } = getState().airDna[stateKey].settings
  withDispatchUpdate(dispatch, {
    nightsPerMonth,
    strPricePerNight: pricePerNight
  })
}
